import { Box, Typography } from "@mui/material";
import React from "react";
import unAuthImg from "../../Assets/Images/unauthorized-person.png";

const UnauthorizePage = ({ message }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        bgcolor: "#f9f9f9",
      }}
    >
      <Box>
        <img
          src={unAuthImg}
          alt="Unauthorized"
          style={{ width: "200px", marginBottom: "20px" }}
        />
      </Box>
      <Box>
        <Typography
          variant="h4"
          color="text.secondary"
          sx={{ marginBottom: "10px" }}
        >
          Sorry!
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ marginBottom: "20px" }}
        >
          {message || "You are not authorized to access."}
        </Typography>
      </Box>
    </Box>
  );
};

export default UnauthorizePage;
